import { memo, useCallback } from 'react';

import { CircleXIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

export type WorkspaceImportsCloseButtonProps = {
  onCloseImportsPane: () => void;
};

export const WorkspaceImportsCloseButton = memo(({ onCloseImportsPane }: WorkspaceImportsCloseButtonProps) => {
  const handleClose = useCallback(() => {
    onCloseImportsPane();
  }, [onCloseImportsPane]);

  return (
    <Button
      appearance="ghost"
      className="ads:text-primary text-gray-12"
      color="gray"
      data-testid="WORKSPACE_IMPORTS_CLOSE_BUTTON"
      onClick={handleClose}
      prefix={<CircleXIcon aria-hidden size="xs" />}
      size="small"
      type="button"
    >
      Clear
    </Button>
  );
});

WorkspaceImportsCloseButton.displayName = 'WorkspaceImportsCloseButton';
